export const defaultColor = '#000';
